import { defineComponent as n, createBlock as r, openBlock as l, unref as a, mergeProps as p, withCtx as i, createElementVNode as c } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconEdit",
  __name: "IconEdit",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (m, e) => (l(), r(a(d), p(o, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M20.27 3.73a2.871 2.871 0 0 0-4.06 0L4.724 15.214a.742.742 0 0 0-.183.278l-1.56 3.901c-.408 1.02.604 2.033 1.625 1.625l3.903-1.561a.75.75 0 0 0 .278-.184L20.27 7.79a2.871 2.871 0 0 0 0-4.06m-3 1.06a1.371 1.371 0 0 1 1.94 1.94l-.675.674-1.94-1.939.676-.675M5.519 17.09l1.391 1.392-2.32.928.928-2.32M15.53 6.53l-9.226 9.226 1.939 1.94 9.226-9.227-1.939-1.94",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
